import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "alertFilter" })
export class AlertFilterPipe implements PipeTransform {
  public transform(alerts: any[], filterKey: string, filterBy: string) {
    if (!alerts) {
      return [];
    }
    if (!filterKey || !filterBy) {
      return alerts;
    }

    return alerts.filter((alert: any) => {
      return (
        alert.params[filterKey].toLowerCase().indexOf(filterBy.toLowerCase()) >
        -1
      );
    });
  }
}
